import { render } from "./FileUploaderEditorCmp.vue?vue&type=template&id=3a1b0027"
import script from "./FileUploaderEditorCmp.vue?vue&type=script&lang=js"
export * from "./FileUploaderEditorCmp.vue?vue&type=script&lang=js"

import "./FileUploaderEditorCmp.vue?vue&type=style&index=0&id=3a1b0027&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__